let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8LYwg")).then(() => parcelRequire('6VH3V'));